import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";

import { StartupScreen } from "./StartupScreen";
import { AdvertisingImage } from "./AdvertisingImage";
import { StartupScreenPreview } from "./StartupScreen/Preview";
import { AdvertisingImagePreview } from "./AdvertisingImage/Preview";
import { useSelector } from "react-redux";

export function AdvertisingScreen() {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const tabs: TabsType[] = [
        {
            title: t("Startup screen"),
            content: <StartupScreen />,
            customClassName: "",
        },
        {
            title: t("Advertising image"),
            content: <AdvertisingImage />,
            customClassName: "",
        },
    ];
    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                {" "}
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => {
                            return (
                                <NavItem
                                    key={index}
                                    className={classNames(
                                        "pb-1",
                                        "d-flex align-items-center text-nowrap",
                                        {
                                            "disable-nav-item__clz":
                                                activeTab !== index,
                                        },
                                        element.customClassName
                                    )}
                                    style={{
                                        cursor: "pointer",
                                        borderBottom:
                                            activeTab === index
                                                ? `${mainColor} 3px solid`
                                                : "",
                                    }}
                                >
                                    <NavLink
                                        className={classNames(
                                            "text-dark w-100",
                                            {
                                                "active customer-account-menu-nav-link-active__clz":
                                                    activeTab === index,
                                                "customer-account-menu-nav-link-disable__clz":
                                                    activeTab !== index,
                                            }
                                        )}
                                        onClick={() => {
                                            toggleNav(index);
                                        }}
                                    >
                                        <span
                                            className="px-2"
                                            style={{
                                                font:
                                                    "normal normal 600 20px/27px  Segoe UI",
                                            }}
                                        >
                                            {element.title}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            );
                        })}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => {
                        return (
                            <TabPane
                                tabId={index}
                                key={index}
                                style={{ height: "90%" }}
                            >
                                {element.content}
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                {activeTab === 0 && <StartupScreenPreview />}
                {activeTab === 1 && <AdvertisingImagePreview />}
            </div>
        </div>
    );
}
